export default __webpack_public_path__ + "static/media/Air Textured Yarn.a78e7ec7.jpg";